import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { searchStore } from '@blade-sxp/search-center/store/search';
// import RouteBtn from '@blade-sxp/search-center/components/route-btn.vue';
import RouteBtn from '@blade-sxp/data-mining/pages/companions/components/result/result.vue';
import sliderInput from '@blade/common/components/slider-input/index.vue';
import virtualList from '@blade/common/components/virtual-list/index.vue';
import routePage from '@blade-sxp/search-center/pages/components/result/components/routePage.vue';
// import FeatureInput from '@blade-sxp/search-center/pages/components/result/components/features/index.vue';
import sort from '@blade-sxp/search-center/pages/components/result/components/sort/index.vue';
import { getFeatures, allTrack, cleanAll, deleteTrack, trackSpace, addMinMapNode, getMindMapsApi, deleteMindMapsApi, } from '@blade-sxp/search-center/api/index';
// import { getFeatures, allTrack, cleanAll, deleteTrack, trackSpace } from '@blade-sxp/search-center/api/index';
import { fromPage, trackSpaceType, nodeType, queryType } from '@blade-sxp/search-center/interfaces/enum';
import FeatureInput from '@blade-sxp/search-center/pages/components/result/attrbutes-cascader-select/index.vue';
import { featrueType } from '@blade-sxp/search-center/interfaces/index';
import ContainImg from '@blade-sxp/search-center/pages/components/contain-img.vue';
import RouteEncephalogram from '@blade-sxp/search-center/components/route-btn.vue';
import DetailsPage from '@blade/common/pages/result-details/index.vue';
let default_1 = class default_1 extends Vue {
    form;
    resultList;
    total;
    disabled;
    type;
    page;
    trackType;
    sourceImageUrl;
    loading;
    codeJson;
    allNum = 0;
    openDetail = false;
    showPath = true;
    // detailsData: ImgList[] | null = null;
    detailsIndex = 0;
    detailsType = '';
    maxHeight = 100;
    feature = fromPage.FEATURES_PAGE;
    routeDialogVisible = false;
    // hover框轨迹数据
    selectedImg = [];
    featureOptions = []; // 属性过滤
    allFeatures;
    filterVisible = false; // 滚动吸顶
    distance = '';
    styleSize = {
        width: 166,
        height: 230,
    }; // 卡片宽高
    screeWidth = 0;
    screeHeight = 0;
    spacing = [20, 20]; // 图片间距
    pageSize = 56; // 每页多少数据
    checkRoute = false;
    isBlur = localStorage.getItem('privacyMode') === 'true';
    activeNameTab = '';
    featureLabel = [];
    objectInfoEncephalogram = {
        routeImageUrl: require('@blade-sxp/search-center/assets/images/group.png'),
        routeText: this.$t('relation').toString(),
        gernerateRelation: this.$t('gernerateRelation').toString(),
        selectedImg: [],
        allNum: 0,
        disabled: false, // 是否禁用
    };
    routeDisabled = false; // 轨迹按钮
    addDataType = ''; // 添加脑图/轨迹类型
    activeTabArr = {
        'FACE&BODY': queryType.FACE_BODY,
        'BODY&FACE': queryType.BODY_FACE,
    };
    get typeName() {
        return this.tabList.find((e) => e.code === this.activeName)?.name || '';
    }
    get selectFeature() {
        return Object.values(this.featureLabel).map((e) => e.label);
    }
    get tabList() {
        return searchStore.tabList;
    }
    get featrueKey() {
        return featrueType[this.activeName];
    }
    get activeName() {
        return searchStore.tabActive;
    }
    set activeName(newValue) { }
    changeFeatureLabel(val) {
        this.featureLabel = val;
    }
    // 属性筛选
    changeAttributesObj(val) {
        // 处理成后端需要的格式
        let attributeMaps = {}; // 属性值不固定
        if (val?.length) {
            val?.forEach((element) => {
                attributeMaps[element[0]] = [];
            });
            for (let attrbuteName in attributeMaps) {
                val?.forEach((element, index) => {
                    if (attrbuteName === element[0]) {
                        val[index]?.forEach((item, itemIndex) => {
                            if (itemIndex !== 0) {
                                attributeMaps[attrbuteName]?.push(item);
                            }
                        });
                    }
                });
            }
        }
        this.$emit('feature', attributeMaps);
    }
    // 轨迹ID删除 同步页面?
    changeIdempotentId(imageId) {
        let i = this.resultList.findIndex((item) => item.idempotentId === imageId);
        this.$set(this.resultList[i], 'existsUserTrack', false);
        const existsIndex = this.resultList[i].userSpaceExistsVOS.findIndex((exists) => exists.spaceType === trackSpaceType.USER_TRACK);
        this.resultList[i].userSpaceExistsVOS[existsIndex].exists = false;
    }
    mounted() {
        this.screeWidth = this.$refs['content'].offsetWidth;
        this.screeHeight = document.documentElement.clientHeight - 167;
        this.getFeatures();
        // 获取脑图节点总数量
        this.getAllMinMapNode();
    }
    isUserSpaceExistsVOS(val) {
        if (this.addDataType === trackSpaceType.CORE_NODE) {
            const res = val.find((el) => {
                return el.spaceType === trackSpaceType.CORE_NODE;
            });
            return res;
        }
        else if (this.addDataType === trackSpaceType.GROUP_TYPE_TRACK) {
            const res = val.find((el) => {
                return el.spaceType === trackSpaceType.USER_TRACK;
            });
            return res;
        }
        else if (this.addDataType === trackSpaceType.RESULT_NODE) {
            const res = val.find((el) => {
                return el.spaceType === trackSpaceType.RESULT_NODE;
            });
            return res;
        }
    }
    // 打开详情框
    onImgClick(val) {
        console.log('val', val);
        this.activeNameTab = this.activeName;
        this.openDetail = true;
        this.detailsIndex = val.idIndex;
    }
    closeDetails() {
        this.openDetail = false;
    }
    next() {
        this.detailsIndex++;
    }
    prev() {
        this.detailsIndex--;
    }
    showBtn(btnPath) {
        this.showPath = btnPath;
    }
    scrollTop(val) {
        const top = val;
        if (top > 100) {
            this.filterVisible = true;
            this.distance = 'distance';
        }
        else {
            this.filterVisible = false;
            this.distance = '';
            this.$refs.cascader.$children[0].$children[0].dropDownVisible = false;
        }
    }
    // 排序
    changeSort(val) {
        this.$emit('sort', val);
    }
    changeFilter() {
        this.filterVisible = !this.filterVisible;
    }
    // 获取属性过滤接口
    getFeatures() {
        getFeatures().then((res) => {
            this.allFeatures = res;
            this.trans2Option();
        });
    }
    // 属性过滤
    trans2Option() {
        const featrues = this.allFeatures?.[this.featrueKey] || [];
        this.featureOptions = [];
        featrues.forEach((e) => {
            this.featureOptions.push({
                value: e.key,
                label: e.keyName,
                checked: false,
                checkedValue: e.type === 'BOOLEAN_TYPE' ? 'FALSE' : undefined,
                radioParent: e.type === 'BOOLEAN_TYPE',
                children: e.type === 'BOOLEAN_TYPE'
                    ? undefined
                    : e.values?.map((child) => {
                        return {
                            value: child.valueKey,
                            label: child.valueName,
                            radio: e.type === 'BOOLEAN_TYPE',
                        };
                    }),
            });
        });
    }
    // 获取所有脑图
    getAllMinMapNode() {
        const param = {
            nodeType: null,
        };
        getMindMapsApi(param).then((res) => {
            this.objectInfoEncephalogram.allNum = res;
        });
    }
    activeTab() {
        // 人脸人体联合 传 人脸   人体人脸联合 传 人体
        return this.activeTabArr[this.activeName] ?? this.activeName;
    }
    // 列表添加脑图
    addMinMapNode(img) {
        // 从index 路由拿到参数
        const { codeType, parentId } = this.codeJson;
        const params = {
            ...img,
            nodeType: codeType || nodeType.NODE_TYPE_CORE,
            parentNodeId: parentId,
            trackType: this.activeTab(),
        };
        addMinMapNode(params).then((res) => {
            // 添加脑图成功勾选 获取当前索引
            let i = this.resultList.findIndex((item) => item.idempotentId === img.idempotentId);
            const existsIndex = this.resultList[i].userSpaceExistsVOS.findIndex((exists) => exists.spaceType === this.addDataType);
            this.resultList[i].userSpaceExistsVOS[existsIndex].exists = true;
            this.showPath = false;
            // 总数量
            this.objectInfoEncephalogram.allNum = res;
        });
    }
    clickRoute(img) {
        if (this.addDataType === trackSpaceType.GROUP_TYPE_TRACK) {
            // 添加轨迹
            const existsData = img.userSpaceExistsVOS.find((item) => item.spaceType === trackSpaceType.USER_TRACK);
            if (!existsData.exists) {
                if (this.allNum === 50) {
                    return this.$message.error(this.$t('track'));
                }
                return this.addRoute(img);
            }
            this.deletedRoute(img);
        }
        else {
            // 判断是脑图节点 || 检索 是添加还是删除
            const existsData = img.userSpaceExistsVOS.find((item) => item.spaceType === this.addDataType);
            if (!existsData.exists) {
                return this.addMinMapNode(img);
            }
            // 添加脑图 deleteMindMapsApi
            this.deleteMindMaps(img);
        }
    }
    // 脑图列表删除
    deleteMindMaps(img) {
        const { idempotentId, imageFeature } = img;
        // this.codeJson.codeType 没有 则为核心节点 反之检索结果
        const param = {
            idempotentId: idempotentId,
            nodeType: this.codeJson?.codeType ? nodeType.NODE_TYPE_RESULT : nodeType.NODE_TYPE_CORE,
            trackSpaceType: trackSpaceType.TRACK_SPACE_TYPE_MIND_MAP,
            trackType: imageFeature.featureType,
            parentNodeId: this.codeJson?.parentId, // 父节点ID 检索结果时有
        };
        deleteMindMapsApi(param).then((res) => {
            let i = this.resultList.findIndex((item) => item.idempotentId === idempotentId);
            const existsIndex = this.resultList[i].userSpaceExistsVOS.findIndex((exists) => exists.spaceType === this.addDataType);
            // 当前选中的给取消选中状态
            this.resultList[i].userSpaceExistsVOS[existsIndex].exists = false;
            // 总数量
            this.objectInfoEncephalogram.allNum = res;
        });
    }
    // 轨迹列表
    deletedRoute(img) {
        const route = this.selectedImg.find((e) => e.idempotentId === img.idempotentId);
        if (!route)
            return;
        this.deleteRoute(route, img);
    }
    // 列表删除轨迹
    deleteRoute(imageId, img) {
        // this.detailLoading = true;
        const route = this.selectedImg.find((e) => e.idempotentId === imageId.idempotentId);
        deleteTrack(Number(route.id))
            .then((res) => {
            this.getAllCount();
            let i = this.resultList.findIndex((item) => item.idempotentId === imageId.idempotentId);
            const existsIndex = this.resultList[i].userSpaceExistsVOS.findIndex((exists) => exists.spaceType === trackSpaceType.USER_TRACK);
            this.resultList[i].userSpaceExistsVOS[existsIndex].exists = false;
            this.showPath = true;
        })
            .finally(() => {
            // this.detailLoading = false;
        });
    }
    addRoute(img) {
        const params = {
            ...img,
            trackType: this.activeTab(),
        };
        // this.detailLoading = true;
        trackSpace(params)
            .then((res) => {
            let i = this.resultList.findIndex((item) => item.idempotentId === img.idempotentId);
            const existsIndex = this.resultList[i].userSpaceExistsVOS.findIndex((exists) => exists.spaceType === trackSpaceType.USER_TRACK);
            this.resultList[i].userSpaceExistsVOS[existsIndex].exists = true;
            this.showPath = false;
            this.getAllCount();
        })
            .finally(() => {
            // this.detailLoading = false;
        });
    }
    openTrack() {
        this.routeDialogVisible = true;
    }
    close() {
        this.getAllCount();
    }
    selectable(boolean) {
        this.checkRoute = !this.checkRoute;
        // 类型为轨迹
        this.addDataType = trackSpaceType.GROUP_TYPE_TRACK;
        if (!boolean) {
            this.getAllCount();
        }
        // 点开轨迹 禁用脑图
        this.objectInfoEncephalogram.disabled = !this.objectInfoEncephalogram.disabled;
    }
    // 获取轨迹图片数量
    getAllCount() {
        allTrack().then((res) => {
            this.allNum = res.length;
            this.selectedImg = res;
        });
    }
    deleteImg(imageId, data) {
        deleteTrack(imageId).then((res) => {
            let i = this.resultList.findIndex((item) => item.idempotentId === data.idempotentId);
            const existsIndex = this.resultList[i].userSpaceExistsVOS.findIndex((exists) => exists.spaceType === trackSpaceType.USER_TRACK);
            this.resultList[i].userSpaceExistsVOS[existsIndex].exists = true;
            if (i !== -1) {
                this.resultList[i].userSpaceExistsVOS[existsIndex].exists = false;
            }
            this.getAllCount();
        });
    }
    // 清空全部轨迹
    clearAlltrack() {
        // console.log('清空hover弹框全部轨迹');
        cleanAll().then((res) => {
            this.getAllCount();
            this.resultList.forEach((item) => {
                const existsIndex = item.userSpaceExistsVOS.findIndex((exists) => {
                    return exists.spaceType === this.addDataType;
                });
                item.existsUserTrack = false;
                existsIndex > -1 && (item.userSpaceExistsVOS[existsIndex].exists = false);
            });
        });
    }
    handleClick(val) {
        // tab 页切换
        searchStore.updateTabActive(val.name);
        this.form.attributesObj = {};
        this.$emit('active-tab', val.name);
        this.trans2Option();
    }
    // 分页
    current(val) {
        this.$emit('current', val);
    }
    // 相似度
    changeThreshold(val) {
        if (val < 30)
            val = 30;
        this.$emit('threshold', val);
    }
    startSelection(val) {
        this.checkRoute = !this.checkRoute;
        if (this.codeJson?.codeType) {
            this.addDataType = trackSpaceType.RESULT_NODE;
        }
        else {
            // 类型为脑图
            this.addDataType = trackSpaceType.CORE_NODE;
        }
        // 点开脑图 禁用轨迹
        this.routeDisabled = !this.routeDisabled;
    }
};
__decorate([
    Prop()
], default_1.prototype, "form", void 0);
__decorate([
    Prop()
], default_1.prototype, "resultList", void 0);
__decorate([
    Prop()
], default_1.prototype, "total", void 0);
__decorate([
    Prop()
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "page", void 0);
__decorate([
    Prop()
], default_1.prototype, "trackType", void 0);
__decorate([
    Prop()
], default_1.prototype, "sourceImageUrl", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop({ default: () => ({ codeType: '', parentId: '' }) })
], default_1.prototype, "codeJson", void 0);
default_1 = __decorate([
    Component({
        name: 'search-result',
        components: { RouteEncephalogram, DetailsPage, routePage, ContainImg, RouteBtn, FeatureInput, sliderInput, sort, virtualList },
        i18n: {
            messages: {
                zh: {
                    result: '{count} 结果',
                    similarity: '相似度：',
                    similar: '{num}% 相似度',
                    loading: '加载中......',
                    route: '轨迹',
                    generateRoute: '轨迹还原',
                    cancel: '取消',
                    clear: '全部删除',
                    select: '{num} 选中',
                    track: '轨迹还原时空卡片数达到50张最大限制',
                    noData: '暂无数据',
                    Features: '特征',
                    relation: '关系',
                    gernerateRelation: '生成脑图',
                },
                en: {
                    result: '{count} results',
                    similarity: 'Similarity：',
                    similar: '{num}% Similarity',
                    loading: 'loading......',
                    route: 'Route',
                    generateRoute: 'Generate Route',
                    cancel: 'Cancel',
                    clear: 'Clear All',
                    select: '{num} Selected',
                    track: 'The number of selected trajectory restoration records reaches the maximum limit of 50.',
                    noData: 'No data',
                    Features: 'Features',
                    relation: 'relation',
                    gernerateRelation: 'Gernerate Relation',
                },
            },
        },
    })
], default_1);
export default default_1;
